import { camelizeKeys } from 'humps';
import { ApiError } from '@rambler-id/errors';
import { decamelizeRpcKeys } from '../utils/keys';
import { request } from './transport';
export const avatarsRpc = async (method, payload) => {
    const upload = method.match(/upload_avatar$/);
    let json;
    try {
        const response = await request(`//avatars.rambler.ru/${upload ? 'upload' : 'rpc'}`, {
            body: upload
                ? payload
                : JSON.stringify({
                    method,
                    params: [decamelizeRpcKeys(payload)],
                    rpc: '2.0'
                }),
            method: 'post',
            credentials: 'include',
            headers: {
                'Content-Type': upload ? 'multipart/form-data' : 'application/json'
            }
        });
        json = await response.json();
    }
    catch (error) {
        throw new ApiError({
            code: 0,
            message: 'api does not respond',
            details: {
                method
            }
        });
    }
    const { status, error, ...rest } = camelizeKeys(json.result);
    if (status === 'OK' && error == null) {
        return rest;
    }
    if (error == null) {
        throw new ApiError({
            code: 0,
            message: 'api failed',
            details: {
                method
            }
        });
    }
    throw new ApiError({
        code: error.errno,
        message: error.strerror,
        details: {
            method,
            ...rest
        }
    });
};
